import { c as _c } from "react/compiler-runtime";
import { TourCardCarouselNavigationPropertiesType } from "@website/accommodation-ui/tour-card/tour-card-carousel/types";
import { MaterialIcon } from "@website/icons/material";
import { FC } from "react";
export const TourCardCarouselNavigation: FC<TourCardCarouselNavigationPropertiesType> = properties => {
  const $ = _c(13);
  const {
    onChange
  } = properties;
  let t0;
  if ($[0] !== onChange) {
    t0 = () => onChange("next");
    $[0] = onChange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon name="chevron_right" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <button className="bg-on-surface-high-emphasis size-7 rounded-full px-1.5 text-white" onClick={t0} type="button">{t1}</button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onChange) {
    t3 = () => onChange("prev");
    $[5] = onChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon name="chevron_left" variant="sharp" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <button className="bg-on-surface-high-emphasis size-7 rounded-full px-1.5 text-white" onClick={t3} type="button">{t4}</button>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="absolute bottom-1/2 right-0 z-10 flex w-full translate-y-1/2 transform-gpu justify-between px-4 max-md:hidden">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};